module.exports = __webpack_public_path__ + "img/solution-finance-advantage4.f629bbd2.svg";